import { css, SerializedStyles } from '@emotion/core'

import { disabledBg, disabledText } from '../constants/colorTokens'
import { TagColor } from '../types'

export const getDisabledStyle = (color: TagColor): SerializedStyles => css`
  background-color: ${disabledBg[color]};
  border-color: transparent;
  color: ${disabledText[color]};
  pointer-events: none;
`
